var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16091",
    "data-name": "Group 16091",
    transform: "translate(-1544 -143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3422",
    "data-name": "Rectangle 3422",
    width: 30,
    height: 30,
    transform: "translate(1544 143)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1548 146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11390",
    "data-name": "Path 11390",
    d: "M18.114,5.73H15.262A3.412,3.412,0,0,0,11.918,3H10.553A3.412,3.412,0,0,0,7.21,5.73H4.357A3.357,3.357,0,0,0,1,9.087v8.3a3.357,3.357,0,0,0,3.357,3.357h5.657a.682.682,0,1,0,0-1.365H4.357a1.993,1.993,0,0,1-1.993-1.993V12.1L9.039,14a8.018,8.018,0,0,0,4.395,0l6.674-1.9v5.289a1.993,1.993,0,0,1-1.993,1.993H17.036a.682.682,0,0,0,0,1.365h1.078a3.357,3.357,0,0,0,3.357-3.357v-8.3A3.357,3.357,0,0,0,18.114,5.73ZM10.553,4.365h1.365A2.047,2.047,0,0,1,13.836,5.73H8.629a2.047,2.047,0,0,1,1.924-1.365Zm2.5,8.325a6.612,6.612,0,0,1-3.644,0L2.365,10.677V9.087A1.993,1.993,0,0,1,4.357,7.094H18.114a1.993,1.993,0,0,1,1.993,1.993v1.59Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfession);
export default __webpack_public_path__ + "static/media/profession.5c5e682db449e34c6fcd04348a3ea3bc.svg";
export { ForwardRef as ReactComponent };